import { useGetMediaQuery, useGetFileCourseInfoQuery } from '../mediaApi';

export const useMedia = (params = {}) => {
  return useGetMediaQuery(params, {
    selectFromResult: ({ data, isLoading, isError, error }) => ({
      mediaData: data,
      isLoading,
      isError,
      error,
    }),
  });
};

export const useFileCourseInfo = (id) => {
  return useGetFileCourseInfoQuery({ id }, {
    selectFromResult: ({ data, isLoading, isError, error }) => ({
      fileCourseInfo: data,
      isLoading,
      isError,
      error,
    }),
    skip: !id,
  });
};
